import { Modal } from '@components/Modal';
import { Button, Loader, TrashIcon, Typography } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmModalProps {
	isOpened: boolean;
	isPending: boolean;
	description: string;
	onConfirm: () => void;
	onCancel: () => void;
}

export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
	isOpened,
	isPending,
	description,
	onConfirm,
	onCancel,
}) => {
	const { t } = useTranslation('', { keyPrefix: 'listOfOperations.deleteOperation' });

	return (
		<Modal className="space-y-space-24 text-center" isOpened={isOpened}>
			<div className="inline-block rounded-full border border-status-error-300 bg-status-error-50 p-space-16">
				<TrashIcon className="text-status-error-500" />
			</div>
			<Typography className="overflow-hidden text-ellipsis" level="h2">
				{description}
			</Typography>
			<div className="space-y-space-8">
				<Button
					className="w-full"
					disabled={isPending}
					onClick={onConfirm}
					variant="primary-black"
				>
					{isPending && <Loader className="w-space-24! h-space-24!" />}
					{t('delete')}
				</Button>
				<Button
					className="w-full"
					disabled={isPending}
					onClick={onCancel}
					variant="secondary"
				>
					{t('cancel')}
				</Button>
			</div>
		</Modal>
	);
};
